/* eslint-disable prettier/prettier */
<template>
  <div class="padding-10">
    <v-card class="padding-5" v-if="!isLoading">
      <v-form v-model="isValid" ref="form">
        <Form v-model="form"></Form>
      </v-form>
      <label> Zone Message</label>
      <editor :items="technicians" v-model="message"></editor>
      <Footer :item="user" @update="update" @save="save"></Footer>
    </v-card>
  </div>
</template>

<script>
import Form from "./create/Form.vue";
import Footer from "./create/Footer";
import { auth, technicians, serviceFields} from "../../assets/js/firebase";
import { formatPhone, getDate } from "../../assets/js/common";
import Editor from "../templates/create/Editor.vue";
import customerModal from '../../assets/js/customer.modal';
import { technicianTypes } from "../../assets/js/default";

export default {
  components: {
    Footer,
    Form,
    Editor,
  },
  data() {
    return {
      types: technicianTypes,
      isValid: false,
      isLoading: true,
      form: {
        phone: "",
        first_name: "",
        last_name: "",
        abilities: "",
        type: "",
        email : "",
        zones: [],
      },
      message: "",
      user: {},
    };
  },
  computed: {
    technicians() {
      let list = this.$store.getters.technicians;
      let items = JSON.parse(JSON.stringify(list));
      return items.map((i) => ({
        ...i,
        name: `${i.name} ${formatPhone(i.phone)}`,
      }));
    },
  },
  methods: {
    async save() {
      const vm = this;
      try {
        let { isValid, form } = vm;
        vm.$refs.form.validate();
        if (!isValid) return;
        let zones = form.zones || [];
        if (zones.indexOf("all") != -1 && zones.length > 1) {
          vm.$alert.show(
            "Please unselect other zones when you select all zones"
          );
          return;
        }

        vm.$root.loader = true;
        let date = getDate();
        form.created_at = date;
        form.updated_at = date;
        form.text = "";
        form.unread = "";
        form.chat_at = "";
        form.updated_by = auth.currentUser.email;
        let snap = await technicians.doc(form.phone).get();
        if (snap.exists) {
          vm.$root.loader = false;
          vm.$root.alert("A technician already exists with same phone");
          return;
        }
       await technicians
         .doc(form.phone)
         .set({ ...form, message: this.message });
      const typeData= this.types.filter(d=> d.name == customerModal.OUTSIDE_CONTRACTOR);
      const typeId = typeData[0].value;
      if(this.form.type==typeId){
          const id = customerModal.OUTSIDE_TECHNICIAN;
          const newOption = `ASK ${this.form.first_name}`;
         this.addNewOptionsToServiceFieldById(id,newOption);
        }
        vm.$root.loader = false;
        vm.$router.replace("/technicians");
      } catch (error) {
        vm.$root.loader = false;
        vm.$root.alert(error.message);
      }
    },
    async getServiceFieldById(id) {
  const vm = this;
  vm.$root.loader = true;
  try {
    let docRef = await serviceFields.doc(id).get();

    if (docRef.exists) {
      let docData = docRef.data();
      vm.$root.loader = false;
      return docData;
    } else {
      vm.$root.loader = false;
      vm.$root.alert("No document found with the provided ID.");
      return null;
    }
  } catch (error) {
    vm.$root.loader = false;
    vm.$root.alert(error.message);
  }
},

    async update() {
      const vm = this;
      try {
        let { isValid, form } = vm;
        vm.$refs.form.validate();
        if (!isValid) return;
        let zones = form.zones || [];
        if (zones.indexOf("all") != -1 && zones.length > 1) {
          vm.$alert.show(
            "Please unselect other zones when you select All Zones"
          );
          return;
        }
        vm.$root.loader = true;
        let date = getDate();
        form.created_at = date;
        form.updated_at = date;
        form.updated_by = auth.currentUser.email;
        let { id } = vm.$route.params;
        if (id !== vm.form.phone) {
          let snap = await technicians.doc(form.phone).get();
          if (snap.exists) {
            vm.$root.loader = false;
            vm.$root.alert("A technician already exists with same phone");
            return;
          }
        }
        await technicians
          .doc(form.phone)
          .update({ ...form, message: this.message });
        vm.$root.loader = false;
        vm.$router.replace("/technicians");
      } catch (error) {
        vm.$root.loader = false;
        vm.$root.alert(error.message);
      }
    },
    async init() {
      const vm = this;
      let { name, params } = vm.$route;
      if (name === "technicians-update") {
        let { id } = params;
        vm.$root.loader = true;
        try {
          let user = await technicians.doc(id).get();
          vm.$root.loader = false;
          if (!user.exists) {
            vm.$root.alert("Technician not found");
            vm.$router.replace("/technicians");
            return;
          }
          let {
            first_name,
            last_name,
            phone,
            abilities,
            type,
            zones,
            message,
            email
          } = user.data();
          vm.form = {
            first_name,
            last_name,
            phone,
            abilities,
            type,
            email,
            zones: zones || [],
          };
          vm.message = message;
          vm.isLoading = false;
        } catch (error) {
          vm.$root.loader = false;
          vm.$root.alert(error.message);
        }
      } else {
        vm.isLoading = false;
      }
    },
    async addNewOptionsToServiceFieldById(id, newOptions) {
       const vm = this;
      vm.$root.loader = true;
      try {
        let docRef = await serviceFields.doc(id).get();
    
    if (docRef.exists) {
      let currentData = docRef.data();
      let currentOptions = currentData.options || [];
      const newData ={name:newOptions, value: newOptions};
       currentOptions.push(newData);
      await serviceFields.doc(id).update({
        options: currentOptions,
        updated_at: getDate(),
      });

      vm.$root.loader = false;
      vm.$root.alert("Options added successfully.");
    } else {
      vm.$root.loader = false;
      vm.$root.alert("Document not found.");
    }
  } catch (error) {
    vm.$root.loader = false;
    vm.$root.alert(error.message);
  }
}
  },
  mounted() {
    this.init();
  },
};
</script>

<style></style>
